import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import Tip from './Tip';
import TipDivider from './TipDivider';
import s from './SubscriptionTips.scss';

export interface Props {
  moduleId: number;
  className?: string;
}

const SubscriptionTips: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  // TODO: Replace readMoreHref with knowledge base article links
  return (
    <div className={c(s['root'], className)}>
      <Tip
        heading={t('widgets.subscriptionsSection.tips.top.heading')}
        text={t('widgets.subscriptionsSection.tips.top.text')}
        readMoreHref="https://www.deviantart.com/team/journal/Tips-and-Best-Practices-for-Subscriptions-889324535"
      />
      <TipDivider className={s['divider']} />
      <Tip
        heading={t('widgets.subscriptionsSection.tips.bottom.heading')}
        text={t('widgets.subscriptionsSection.tips.bottom.text')}
        readMoreHref="https://www.google.com"
      />
    </div>
  );
};
SubscriptionTips.displayName = 'SubscriptionTips';

export default SubscriptionTips;
